import { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { useAuth } from '../auth/AuthProvider'

/**
 * Landningssidan för magic link-länken.
 *
 * supabase-js plockar upp token ur URL:en själv (detectSessionInUrl), så det
 * enda som behövs här är att vänta in sessionen och sedan skicka vidare.
 */
export function AuthCallback() {
  const { session, loading } = useAuth()
  const navigate = useNavigate()
  const [tooSlow, setTooSlow] = useState(false)

  useEffect(() => {
    if (!loading && session) navigate('/', { replace: true })
  }, [loading, session, navigate])

  useEffect(() => {
    const t = setTimeout(() => setTooSlow(true), 6000)
    return () => clearTimeout(t)
  }, [])

  return (
    <div className="page" style={{ maxWidth: 460 }}>
      <div className="card stack">
        <p>Loggar in…</p>
        {tooSlow && !session && (
          <>
            <div className="notice notice--error">
              Det tog längre tid än väntat. Länken kan ha gått ut eller redan använts.
            </div>
            <button onClick={() => navigate('/logga-in', { replace: true })}>
              Begär en ny länk
            </button>
          </>
        )}
      </div>
    </div>
  )
}
